import React from 'react';
import { IconType } from 'react-icons';
import styled from 'styled-components';
import { IconWrapper } from './IconWrapper';
import { gradientText } from './utils/gradientText';

export interface ServiceType {
  icon: string | IconType;
  title: string;
  description: string;
}

export interface StepType {
  number: string;
  title: string;
  description: string;
}

const Card = styled.div<{ variant?: CardVariant }>`
  background: white;
  display: flex;
  flex-direction: column;

  ${({ variant, theme }) =>
    variant === CardVariant.Minimal
      ? `
    padding: 0;
    box-shadow: none;
    border-radius: 0;
    min-height: auto;
  `
      : `
    padding: ${theme.spacing.md};
    box-shadow: ${theme.shadows.lg};
    border-radius: ${theme.borderRadius.md};
    min-height: 216px;
  `}

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
  min-height: 140px;
  ${({ variant, theme }) =>
    variant === CardVariant.Minimal
      ? `
    padding: 0;
    `
      : `padding: ${theme.spacing.sm}`}
`;

const CardContent = styled.div`
  flex-grow: 1;
  // margin-bottom: ${({ theme }) => theme.spacing.md};
`;

const Title = styled.h3`
  ${gradientText}
  font-size: ${({ theme }) => theme.typography.fontSizes.xl};
  margin-bottom: ${({ theme }) => theme.spacing.xs};
  font-weight: ${({ theme }) => theme.typography.fontWeights.semibold};
  background: linear-gradient(90deg, #132450 0%, #2b52b6 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 1.25rem;
  }
`;

const Description = styled.p`
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: ${({ theme }) => theme.typography.fontSizes.md};
  line-height: ${({ theme }) => theme.typography.lineHeights.normal};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 14px;
  }
`;

export enum CardVariant {
  Default = 'DEFAULT',
  Minimal = 'MINIMAL',
}

interface ServiceCardProps extends ServiceType {
  variant?: CardVariant;
}

export const ServiceCard: React.FC<ServiceCardProps> = ({
  icon,
  title,
  description,
  variant = CardVariant.Default,
}) => {
  const renderIcon = () => {
    if (typeof icon === 'string') {
      return <img src={icon} alt="" />;
    } else {
      const Icon = icon;
      return <Icon />;
    }
  };

  return (
    <Card variant={variant}>
      <IconWrapper size="large" variant="gradient">
        {renderIcon()}
      </IconWrapper>
      <CardContent>
        <Title>{title}</Title>
        <Description>{description}</Description>
      </CardContent>
    </Card>
  );
};
